import { render } from "./RegUser.vue?vue&type=template&id=7b7741b4"
import script from "./RegUser.vue?vue&type=script&lang=js"
export * from "./RegUser.vue?vue&type=script&lang=js"

import "./RegUser.vue?vue&type=style&index=0&id=7b7741b4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__